const MuiListItem = {
  root: {
    boxShadow:
      "0px 1px 1px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.25);",
    borderRadius: 4,
    cursor: "pointer",
  },
};

export default MuiListItem;
